/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import styles from './styles/controls.css';

export const LatencyText = ({lag}) => (
  <div className={`${styles.streamStatusMessage}`}>
    {lag < 0.5 ? '' : `Latency: ${lag} seconds`}
  </div>
);

LatencyText.propTypes = {lag: PropTypes.number.isRequired};

export default LatencyText;